import React from "react";
import TabSlider from "../../common/TabSlider";
import { SlotTabData } from "../../helper/Helper";
import { ArcadeIcon } from "../../helper/Icon2";
import SwiperSlider from "../../common/SwiperSlider";

function ArcadeTabContent() {
  return (
    <>
      <SwiperSlider
        sectionHeading={"Arcade"}
        icon={<ArcadeIcon />}
        data={SlotTabData}
      />
    </>
  );
}

export default ArcadeTabContent;
